import React, { Component } from "react";
import {
  Button,
  Dimmer,
  Form,
  Grid,
  Image,
  Loader,
  Message,
  Segment,
  Transition,
  Container
} from "semantic-ui-react";

import request from "../utils/request";
import logo from "../assets/img/bump-ticketlogo.png";


const transitions = {
  init: "fade up",
  error: "shake"
};
class MSLogin extends Component {
  constructor(props) {
    super(props);
    
    this.signInMs = this.signInMs.bind(this);
    this.state = {
      loaderVisible: false,    
      errorVisible: "hidden",
      errorMessage: "",
      loaderMessage: "Authenticating...",
      visible: false,
      animation: transitions.init
    };
  }
  toggleVisibility = () => this.setState({ visible: !this.state.visible });
  componentDidMount() {
    this.toggleVisibility();

  }

  signInMs() {    
    var self = this;
    self.setState({
      animation: transitions.error,
      errorVisible: "hidden",
      errorMessage: "",
      loaderMessage: "Authenticating...",
      loaderVisible: true
    });

    return request
      .get(this, "api:/signin")
      .catch(resp => {
        return resp;
      })
      .then(resp => {
        if (resp.status === '1error') {
          self.setState({ animation: transitions.error });
          self.toggleVisibility();
          self.setState({
            errorVisible: "",
            errorMessage: resp.message,
            loaderMessage: "Access Denied",
            loaderVisible: false
          });
          return;
        }        
        window.location.replace(resp.url);
        return;        
      });
  }

  render() {
    const {
      visible,
      animation,
      errorMessage,
      errorVisible,
      loaderVisible,
      loaderMessage
    } = this.state;

    return (
      <Container fluid id="wrapper" className="login">
        <Grid verticalAlign="middle" textAlign="center" padded id="login">
          <Grid.Column mobile={16} tablet={12} computer={6}>
            <Transition visible={visible} animation={animation} duration={500}>
              <Segment>
                <Dimmer inverted active={loaderVisible}>
                  <Loader>{loaderMessage}</Loader>
                </Dimmer>
                <h2>
                  <Image src={logo} size="small" centered alt="BumpCBN Logo" />
                </h2>
                <Message negative floating className={errorVisible}>
                  <p>{errorMessage}</p>
                </Message>
                <Form className="form-signin">
                  <Button primary type="submit" size="large" onClick={this.signInMs}>
                    Let's Go!
                  </Button>
                </Form>
              </Segment>
            </Transition>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default MSLogin;
